import "./Header.css";
import FlokiSteroidLogo from "../../assets/logo.png";
import detectEthereumProvider from "@metamask/detect-provider";
import { ethers } from "ethers";
import { useContext, useEffect } from "react";
import { AppContext } from "../../context/main";
import {
  clearLocalStorage,
  readLocalStorage,
  createLocalStorage,
} from "../../utils/localStorage";

const Header = () => {
  const {
    userWalletAddress,
    setUserWalletAddress,
    isUserConnected,
    setIsUserConnected,
  } = useContext(AppContext);

  useEffect(() => {
    const connectDetails = readLocalStorage();
    if (connectDetails != null) {
      handleWalletConnect();
    }
    handleEvents();
  }, []);

  const handleWalletConnect = async () => {
    if (window.ethereum !== undefined) {
      const provider = new ethers.providers.Web3Provider(
        window.ethereum,
        "any"
      );
      const signer = provider.getSigner();
      const chainId = await signer.getChainId();
      console.log(chainId);
      if (parseInt(chainId) === 56) {
        const allAccounts = await provider.send("eth_requestAccounts", []);
        console.log(allAccounts);
        setUserWalletAddress(allAccounts[0]);
        setIsUserConnected(true);
        createLocalStorage(allAccounts[0], true);
        handleEvents();
      } else {
        alert("You need to connect to MainNet to use DAPP");
      }
    }
  };

  const handleEvents = async () => {
    const provider = await detectEthereumProvider();
    console.log(provider);

    provider.on("chainChanged", (chainId) => {
      const parsedChainId = parseInt(chainId);
      console.log(parsedChainId);
    });

    provider.on("accountsChanged", (accounts) => {
      if (accounts.length > 0) {
        console.log(accounts);
        const currentAccount = accounts[0];
        createLocalStorage(currentAccount, true);
        setUserWalletAddress(currentAccount);
        setIsUserConnected(true);
      }
    });

    provider.on("disconnect", () => {
      console.log("disconnected");
      clearLocalStorage();
      setIsUserConnected(false);
      setUserWalletAddress("");
    });
  };
  return (
    <div className="headerMain">
      <div className="logoDiv">
        <img src={FlokiSteroidLogo} alt="" />
        <p>Staking</p>
      </div>
      {/* 
            <div>
                 <a href="/stakePartTwo" style={{
                     color :'white'
                 }} ><p>Stake Part Two</p></a>
            </div> */}
      <div className="connectSection">
        <button className="connectButton" onClick={() => handleWalletConnect()}>
          {isUserConnected
            ? `${userWalletAddress.slice(0, 7)}...${userWalletAddress.slice(
                userWalletAddress.length - 4,
                userWalletAddress.length
              )}`
            : "Connect Wallet"}
        </button>
      </div>
    </div>
  );
};

export default Header;
